import React from 'react';
import { Subscribe } from 'unstated';

import { LoadableAfterPaint } from '@confluence/loadable';
import { BannerStateContainer } from '@confluence/banners/entry-points/BannerStateContainer.ts';

import { useIsPageEligibleForAdminAnnouncementBanner } from './useIsPageEligibleForAdminAnnouncementBanner.ts';

const AdminAnnouncementBannerInner = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AdminAnnouncementBannerInner" */ './AdminAnnouncementBannerInner.tsx'
			)
		).AdminAnnouncementBannerInner,
});

export const AdminAnnouncementBanner = () => {
	const isPageEligibleForAdminAnnouncementBanner = useIsPageEligibleForAdminAnnouncementBanner();
	if (!isPageEligibleForAdminAnnouncementBanner) {
		return null;
	}
	return (
		<Subscribe to={[BannerStateContainer]}>
			{(bannerState: BannerStateContainer) => {
				return <AdminAnnouncementBannerInner bannerState={bannerState} />;
			}}
		</Subscribe>
	);
};
